const types = {
  //Get Template name
  GET_REAGENTS_START: "GET_REAGENTS_START",
  GET_REAGENTS_SUCCESS: "GET_REAGENTS_SUCCESS",
  GET_REAGENTS_ERROR: "GET_REAGENTS_ERROR",
  GET_REAGENTS_RESET: "GET_REAGENTS_RESET",

  //Create Template name
  CREATE_REAGENTS_START: "CREATE_REAGENTS_START",
  CREATE_REAGENTS_SUCCESS: "CREATE_REAGENTS_SUCCESS",
  CREATE_REAGENTS_ERROR: "CREATE_REAGENTS_ERROR",
  CREATE_REAGENTS_RESET: "CREATE_REAGENTS_RESET",

  //delete Template name
  DELETE_REAGENTS_START: "DELETE_REAGENTS_START",
  DELETE_REAGENTS_SUCCESS: "DELETE_REAGENTS_SUCCESS",
  DELETE_REAGENTS_ERROR: "DELETE_REAGENTS_ERROR",
  DELETE_REAGENTS_RESET: "DELETE_REAGENTS_RESET",

  //update Template name
  UPDATE_REAGENTS_START: "UPDATE_REAGENTS_START",
  UPDATE_REAGENTS_SUCCESS: "UPDATE_REAGENTS_SUCCESS",
  UPDATE_REAGENTS_ERROR: "UPDATE_REAGENTS_ERROR",
  UPDATE_REAGENTS_RESET: "UPDATE_REAGENTS_RESET",

  //single item  name
  SINGLE_REAGENTS_START: "SINGLE_REAGENTS_START",
  SINGLE_REAGENTS_SUCCESS: "SINGLE_REAGENTS_SUCCESS",
  SINGLE_REAGENTS_ERROR: "SINGLE_REAGENTS_ERROR",
  SINGLE_REAGENTS_RESET: "SINGLE_REAGENTS_RESET",
};

export default types;
